import * as Yup from "yup";
import { isSocialLinkValid } from "../../../../utils/socialHelpers";

export const businessBoxv2InitialValues = {
  business_title: "",
  description: "",
  media_url: "",
  business_link: [],
  business_box_cta: [
    { title: "", link: "", is_cta_enabled: false },
    { title: "", link: "", is_cta_enabled: false },
  ],
};

export const businessBoxv2ValidationSchema = Yup.object().shape({
  business_title: Yup.string().trim().required("Title is required"),

  business_link: Yup.array().of(
    Yup.object().shape({
      link: Yup.string()
        .required("URL is required")
        .trim()
        .test("valid-url", "Please enter a valid URL", (value) => {
          if (!value) return false;
          try {
            // Add https:// if protocol is missing
            const urlString = value.match(/^https?:\/\//)
              ? value
              : `https://${value}`;
            const url = new URL(urlString);
            // Check if has valid hostname
            return url.hostname.includes(".");
          } catch (error) {
            return false;
          }
        }),
      is_cta_enabled: Yup.boolean().required(),
      icon: Yup.string(),
    })
  ),
  business_box_cta: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().when("is_cta_enabled", {
        is: true,
        then: (schema) => schema.required("A title is required"),
        otherwise: (schema) => schema,
      }),
      link: Yup.string().when("is_cta_enabled", {
        is: true,
        then: (schema) => schema.required("A link is required"),
        otherwise: (schema) => schema,
      }),
      is_cta_enabled: Yup.boolean().required(), // Ensure this field exists
    })
  ),
});
